import React from 'react';
import { motion } from 'framer-motion';

const LoadingScreen = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6, ease: "easeInOut" }}
      className="fixed inset-0 z-[10000] bg-gradient-to-br from-luxury-charcoal via-luxury-slate to-luxury-charcoal flex items-center justify-center"
    >
      <div className="text-center relative">
        {/* Elegant Logo with Fade + Scale */}
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ 
            scale: 1,
            opacity: 1
          }}
          transition={{ 
            duration: 0.8,
            ease: [0.25, 0.46, 0.45, 0.94]
          }}
          className="mb-8 relative"
        >
          {/* Glow Effect Behind Logo */}
          <motion.div
            animate={{ 
              scale: [1, 1.15, 1],
              opacity: [0.3, 0.5, 0.3]
            }}
            transition={{ 
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut"
            }}
            className="absolute inset-0 bg-luxury-gold blur-3xl"
          />
          
          <img 
            src="/logoHotela/Logo-la-casa-frei.png" 
            alt="Haus Niggemann" 
            className="w-40 h-40 md:w-48 md:h-48 object-contain mx-auto relative z-10"
            loading="eager"
            decoding="async"
          />
        </motion.div>

        {/* Brand Name */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.6 }}
          className="mb-8"
        >
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-2">
            Haus Niggemann
          </h2>
          <div className="w-32 h-0.5 bg-luxury-gold mx-auto mb-3" />
          <p className="text-luxury-cream text-sm md:text-base font-light tracking-wider">
            HOTEL & RESTAURANT
          </p>
        </motion.div>

        {/* Modern Loading Bar */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.4 }}
          className="w-64 md:w-80 mx-auto"
        >
          <div className="h-1 bg-luxury-slate/50 rounded-full overflow-hidden">
            <motion.div
              initial={{ x: '-100%' }}
              animate={{ x: '100%' }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: "easeInOut"
              }}
              className="h-full w-1/2 bg-gradient-to-r from-transparent via-luxury-gold to-transparent"
            />
          </div>
        </motion.div>

        {/* Subtle Text */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: [0, 0.7, 0] }}
          transition={{ 
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="text-luxury-cream/70 text-xs md:text-sm mt-6 tracking-widest"
        >
          LOADING EXPERIENCE
        </motion.p>
      </div>
    </motion.div>
  );
};

// React.memo za optimizaciju
export default React.memo(LoadingScreen);
